module.exports = __webpack_public_path__ + "img/delivery-flier.ba38c72c.jpg";